module.exports = __webpack_public_path__ + "static/media/6.5-tracks.c812d75d.png";